import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { Container, IDestroyOptions, Text, TextStyle } from "pixi.js";
import { gsap } from "gsap";
import { GameFont } from "../../../../common/GameFont";
import { SoundsResourcePackageWrapper } from "../../../../common/resources/SoundsResourcePackageWrapper";
type Timeline = gsap.core.Timeline;

export class WheelErrorMessage extends Container {
    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private errorWheelBackButton: ButtonWithScaleAnimation;
    private errorText: Text;

    public constructor(
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper,
        errorMEssage: string, exitCallback: () => void
    ) {
        super();
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.build(errorMEssage, exitCallback);
        this.once("added", this.hide.bind(this));
    }

    private build(errorMEssage: string, exitCallback: () => void): void {
        this.errorText = new Text(errorMEssage, new WheelErrorTextStyle());
        this.errorText.anchor.set(0.5, 0.5);
        this.addChild(this.errorText);
        this.errorWheelBackButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_x_png);
        this.errorWheelBackButton.pivot.set(this.errorWheelBackButton.width * 0.5, this.errorWheelBackButton.height * 0.5);
        this.errorWheelBackButton.position.set(this.errorText.x, this.errorText.y + this.errorText.height * 0.5 + this.errorWheelBackButton.height * 1.5);
        this.errorWheelBackButton.onUp.add(() => {
            this.errorWheelBackButton.enabled = false;
            exitCallback();
        });
        this.addChild(this.errorWheelBackButton);
    }

    private hide(): void {
        this.visible = false;
    }

    public getShowErrorMessageAnimation(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        this.soundResources.assets_sounds_goldenwheel_new_wheel_purchase_fail_screen_mp3.play();
        animationTimeLine.set(this, { visible: true });
        animationTimeLine.fromTo(this.errorText.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.4 });
        animationTimeLine.fromTo(this.errorWheelBackButton.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.4 });
        animationTimeLine.set(this.errorWheelBackButton, { enabled: true });
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }

    public getHideErrorMessageAnimation(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.to(this.errorWheelBackButton.scale, { x: 0, y: 0, duration: 0.6 });
        animationTimeLine.to(this.errorText.scale, { x: 0, y: 0, duration: 0.6 }, "<");
        animationTimeLine.set(this, { visible: false });
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }


    public override destroy(options?: boolean | IDestroyOptions): void {
        this.errorWheelBackButton.onUp.removeAll();
        super.destroy(options);
    }
}

class WheelErrorTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 50,
            leading: 15
        }));
    }
}
